import { ObserversModule } from '@angular/cdk/observers';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EmptyPlaceholderModule } from '@epicuro-next/ataraxia/empty-placeholder';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { SetDefaultTitle } from '@epicuro-next/directives/set-default-title';
import { ConfigurationModule } from '@epicuro-next/platform/configuration';
import { EnvironmentModule } from '@epicuro-next/platform/environment';
import { FEATURE_NAME } from '@epicuro-next/state/home-state';

import { BuilderContentComponent } from './components/builder-content.component';
import { BuilderContentService } from './services/builder-content.service';

@NgModule({
  imports: [
    CommonModule,
    ObserversModule,
    EnvironmentModule,
    IconsModule,
    ConfigurationModule.forFeature(FEATURE_NAME),
    EmptyPlaceholderModule,
    RouterModule.forChild([
      {
        path: ':templateId',
        component: BuilderContentComponent,
      },
      {
        path: '',
        component: BuilderContentComponent,
        pathMatch: 'full',
      },
    ]),
    SetDefaultTitle,
  ],
  providers: [BuilderContentService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [BuilderContentComponent],
})
export class BuilderContentModule {}
